import React, { useContext } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import Charts from './components/Charts';
import useLoadDigitalPR from './hooks/useLoadDigitalPR';
import PRTableWrapper from './components/PRTableWrapper';
import ClientNotesDialog from './components/ClientNotesDialog';
import MobileTitle from '../../customUI/MobileTitle';
import { storeContext } from '../provider/Provider';
import NoCampaigns from './components/NoCampaigns';
import LinksDialog from './components/LinksDialog';

const DigitalPR = () => {
  useLoadDigitalPR();
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const { state } = useContext(storeContext);


  const hasFilters = state.digitalPR.campaignFilters.fromDate || state.digitalPR.campaignFilters.toDate;

  if ((state.digitalPR.campaignsLoading || state.digitalPR.historicCampaignsLoading) && !hasFilters) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const hasCampaigns = (state.digitalPR.totalCampaigns > 0 || 
   state.digitalPR.historicTotalCampaigns > 0) || hasFilters;

  return hasCampaigns ? (
    <Box>
      {isPhone && <MobileTitle title="Digital PR" />}
      <Charts />
      <PRTableWrapper />
      <ClientNotesDialog />
      <LinksDialog />
    </Box>
  ) : (
    <NoCampaigns />
  );
};

export default DigitalPR;
